import { useState } from 'react';
import { motion } from 'framer-motion';
import { programmationIAData } from '../data/programmationIAData';
import AikupCard from '../components/AikupCard';
import AikupModal from '../components/AikupModal';
import ExpertVisionModal from '../components/ExpertVisionModal';
import VisionAmbitionModal from '../components/VisionAmbitionModal';
import CadreProgramIAModal from '../components/CadreProgramIAModal';
import ConceptAZModal from '../components/ConceptAZModal';
import RACIModal from '../components/RACIModal';
import POC48Modal from '../components/POC48Modal';
import OverviewInAppModal from '../components/OverviewInAppModal';
import ChatbotAIModal from '../components/ChatbotAIModal';
import CodeHubERPModal from '../components/CodeHubERPModal';
import AIHumanBOOMModal from '../components/AIHumanBOOMModal';
import PositionnementModal from '../components/PositionnementModal';
import CadresReferentielsModal from '../components/CadresReferentielsModal';
import TransparenceRadicaleModal from '../components/TransparenceRadicaleModal';
import ARIAModal from '../components/ARIAModal';
import GouvernanceProgrammationIAModal from '../components/GouvernanceProgrammationIAModal';
import MachineIAModal from '../components/MachineIAModal';
import ComiteTIPrismeModal from '../components/ComiteTIPrismeModal';
import AIInsightBubble from '../components/AIInsightBubble';
import Header from '../layout/Header';
import LeadersSection from '../components/LeadersSection';
import FormationGestionDocumentaireCard from '../components/FormationGestionDocumentaireCard';
import ArbrePRIsMECard from '../components/ArbrePRIsMECard';
import LexChatbotPRIsMECard from '../components/LexChatbotPRIsMECard';
import ProgrammationMobileModal from '../components/ProgrammationMobileModal';
import type { ProgrammationIAItem } from '../data/programmationIAData';

export default function ProgrammationIA() {
  const [selectedItem, setSelectedItem] = useState<ProgrammationIAItem | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [expertVisionModal, setExpertVisionModal] = useState<{
    isOpen: boolean;
    expert: 'dany' | 'yannick' | 'francois' | null;
    item: ProgrammationIAItem | null;
  }>({
    isOpen: false,
    expert: null,
    item: null,
  });
  const [isVisionAmbitionOpen, setIsVisionAmbitionOpen] = useState(false);
  const [isCadreProgramIAOpen, setIsCadreProgramIAOpen] = useState(false);
  const [isConceptAZOpen, setIsConceptAZOpen] = useState(false);
  const [isRACIOpen, setIsRACIOpen] = useState(false);
  const [isPOC48Open, setIsPOC48Open] = useState(false);
  const [isOverviewInAppOpen, setIsOverviewInAppOpen] = useState(false);
  const [isChatbotAIOpen, setIsChatbotAIOpen] = useState(false);
  const [isCodeHubERPOpen, setIsCodeHubERPOpen] = useState(false);
  const [isAIHumanBOOMOpen, setIsAIHumanBOOMOpen] = useState(false);
  const [isPositionnementOpen, setIsPositionnementOpen] = useState(false);
  const [isCadresReferentielsOpen, setIsCadresReferentielsOpen] = useState(false);
  const [isTransparenceRadicaleOpen, setIsTransparenceRadicaleOpen] = useState(false);
  const [isARIAModalOpen, setIsARIAModalOpen] = useState(false);
  const [isGouvernanceProgrammationIAOpen, setIsGouvernanceProgrammationIAOpen] = useState(false);
  const [isMachineIAOpen, setIsMachineIAOpen] = useState(false);
  const [isGestionReunionDirectionProgOpen, setIsGestionReunionDirectionProgOpen] = useState(false);
  const [isProgrammationMobileOpen, setIsProgrammationMobileOpen] = useState(false);

  const handleCardClick = (item: ProgrammationIAItem) => {
    if (item.id === 1) {
      setIsVisionAmbitionOpen(true);
    } else if (item.id === 2) {
      setIsCadreProgramIAOpen(true);
    } else if (item.id === 3) {
      setIsConceptAZOpen(true);
    } else if (item.id === 4) {
      setIsRACIOpen(true);
    } else if (item.id === 5) {
      setIsPOC48Open(true);
    } else if (item.id === 6) {
      setIsOverviewInAppOpen(true);
    } else if (item.id === 7) {
      setIsChatbotAIOpen(true);
    } else if (item.id === 8) {
      setIsCodeHubERPOpen(true);
    } else if (item.id === 9) {
      setIsAIHumanBOOMOpen(true);
    } else if (item.id === 10) {
      setIsPositionnementOpen(true);
    } else if (item.id === 11) {
      setIsCadresReferentielsOpen(true);
    } else if (item.id === 12) {
      setIsTransparenceRadicaleOpen(true);
    } else if (item.id === 13) {
      setIsARIAModalOpen(true);
    } else if (item.id === 14) {
      setIsGouvernanceProgrammationIAOpen(true);
    } else if (item.id === 15) {
      setIsGestionReunionDirectionProgOpen(true);
    } else if (item.id === 17) {
      setIsMachineIAOpen(true);
    } else if (item.id === 25) {
      setIsProgrammationMobileOpen(true);
    } else {
      setSelectedItem(item);
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedItem(null), 300);
  };

  const leaders = [
    {
      name: "Eric Durand",
      title: "Directeur de la programmation",
      avatar: "/ED.png",
      vision:
        "Eric est un travailleur acharné, toujours fidèle au poste. Un jugement et un sens de l'analyse qui se démarque toujours en mode solution. Très discret mais vraiment efficace. Il va direct au but, très bon pour une industrie comme BZ. C'est un fit naturel avec BZ et ses clients. Il voit PRIsME comme l'outil qui structure notre excellence en programmation et facilite la livraison de solutions efficaces.",
      attentes:
        "Eric s'attend à ce que PRIsME reflète notre approche directe et efficace. Il veut voir chaque processus optimisé, chaque solution documentée, chaque livrable de qualité. Son objectif : que PRIsME soit l'outil qui facilite le développement tout en maintenant notre excellence et notre fit naturel avec BZ et ses clients.",
      pagePRIsME:
        "La page PRIsME de Programmation & IA reflète notre excellence : cadre PROGRAM-IA, POC 48h, chatbot AI, CodeHub ERP, transparence radicale. C'est notre vitrine d'excellence en développement qui structure et optimise.",
    },
    {
      name: "Guillaume Cloutier",
      title: "Conseiller principal – Programmation & IA",
      avatar: "/GC.png",
      vision:
        "Guillaume challenge la vision et pousse l'équipe à toujours garder le focus sur l'impact client. Il voit PRIsME comme le cockpit qui permet de piloter les bons projets, avec la bonne gouvernance et les bons rituels.",
      attentes:
        "Guillaume s'attend à ce que PRIsME rende évident qui fait quoi, sur quoi on travaille et pourquoi. Il veut de la clarté, des décisions documentées et une gouvernance solide sur les projets clés.",
      pagePRIsME:
        "Pour Guillaume, la page Programmation & IA doit refléter une direction solide : gouvernance claire, comités vivants et décisions traçables.",
    },
    {
      name: "Marc-Antoine Caron (Marco)",
      title: "Product Owner / IA & Architecture",
      avatar: "/MAC.png",
      vision:
        "Marco voit PRIsME comme le moteur qui relie vision produit, architecture et exécution. Il veut que chaque décision IA soit traçable, assumée et alignée sur la stratégie d'affaires.",
      attentes:
        "Marco s'attend à voir les bons rituels de direction programmation, des décisions structurées et des suivis clairs sur les actions critiques.",
      pagePRIsME:
        "Pour Marco, la page Programmation & IA doit être le tableau de bord vivant des décisions produit et techniques.",
    },
  ];

  // Organiser par catégorie - trier pour mettre "Gouvernance" en premier, puis "Produit transverse"
  const categories = Array.from(new Set(programmationIAData.map(item => item.category))).sort((a, b) => {
    if (a === 'Gouvernance') return -1;
    if (b === 'Gouvernance') return 1;
    if (a === 'Produit transverse') return -1;
    if (b === 'Produit transverse') return 1;
    return a.localeCompare(b);
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Header 
        title="Programmation & IA" 
        subtitle="Développement d'applications avec IA intégrée - Cadre PROGRAM-IA pour excellence et rapidité"
      />
      
      <div className="max-w-7xl mx-auto px-8 pb-12">
        <LeadersSection leaders={leaders} title="Nos leaders - Programmation & IA" />
        
        {/* Stats Overview */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-xl shadow-md p-6 border-l-4 border-indigo-500"
          >
            <p className="text-sm text-gray-600 mb-1">Outils Disponibles</p>
            <p className="text-3xl font-bold text-gray-900">{programmationIAData.length}</p>
            <p className="text-xs text-gray-500 mt-1">Frameworks IA</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="bg-white rounded-xl shadow-md p-6 border-l-4 border-green-500"
          >
            <p className="text-sm text-gray-600 mb-1">Score Maturité</p>
            <p className="text-3xl font-bold text-gray-900">
              {Math.round(programmationIAData.reduce((sum, item) => sum + (item.kpiScore || 0), 0) / programmationIAData.length)}%
            </p>
            <p className="text-xs text-gray-500 mt-1">Moyenne excellence</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-white rounded-xl shadow-md p-6 border-l-4 border-purple-500"
          >
            <p className="text-sm text-gray-600 mb-1">Catégories</p>
            <p className="text-3xl font-bold text-gray-900">{categories.length}</p>
            <p className="text-xs text-gray-500 mt-1">Domaines couverts</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="bg-white rounded-xl shadow-md p-6 border-l-4 border-pink-500"
          >
            <p className="text-sm text-gray-600 mb-1">Cadres & Concepts</p>
            <p className="text-3xl font-bold text-gray-900">
              {programmationIAData.filter(item => item.category === 'Cadre Référentiel' || item.category === 'Concept').length}
            </p>
            <p className="text-xs text-gray-500 mt-1">Outils stratégiques</p>
          </motion.div>
        </div>

        {/* Cards par catégorie */}
        {categories.map((category, categoryIndex) => {
          const itemsInCategory = programmationIAData.filter(item => item.category === category);
          
          return (
            <div key={category} className="mb-12">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: categoryIndex * 0.1 }}
                className="flex items-center gap-3 mb-6"
              >
                <div className="flex-1 h-px bg-gradient-to-r from-indigo-500 to-pink-500"></div>
                <h2 className="text-2xl font-bold text-gray-800 px-4">{category}</h2>
                <div className="flex-1 h-px bg-gradient-to-l from-indigo-500 to-pink-500"></div>
              </motion.div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {itemsInCategory.map((item, idx) => {
                  const customLeadersForItem = [
                          {
                            name: 'Eric Durand',
                            avatar: '/ED.png',
                            title: 'Directeur de la programmation',
                          },
                          {
                            name: 'Guillaume Cloutier',
                            avatar: '/GC.png',
                            title: 'Conseiller principal – Programmation & IA',
                          },
                          {
                            name: 'Marc-Antoine Caron (Marco)',
                            avatar: '/MAC.png',
                            title: 'Product Owner / IA & Architecture',
                          },
                        ];

                  return (
                    <motion.div
                      key={item.id}
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: categoryIndex * 0.1 + idx * 0.05 }}
                    >
                      <AikupCard
                        item={item}
                        onClick={() => handleCardClick(item)}
                        onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                          setExpertVisionModal({
                            isOpen: true,
                            expert,
                            item,
                          });
                        }}
                        index={idx}
                        customLeaders={customLeadersForItem}

                      />
                    </motion.div>
                  );
                })}
              </div>
            </div>
          );
        })}

        {/* Cards Formation, Arbre PRIsME et LEX ChatBot PRIsME */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          <FormationGestionDocumentaireCard
            department="Programmation & IA"
            domain="Programmation & IA"
            index={0}
          />
          <ArbrePRIsMECard
            index={1}
          />
          <LexChatbotPRIsMECard
            department="Programmation & IA"
            domain="Programmation & IA"
            index={2}
          />
        </div>
      </div>

      <AikupModal
        item={selectedItem as any}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />

      <VisionAmbitionModal
        isOpen={isVisionAmbitionOpen}
        onClose={() => setIsVisionAmbitionOpen(false)}
      />

      <CadreProgramIAModal
        isOpen={isCadreProgramIAOpen}
        onClose={() => setIsCadreProgramIAOpen(false)}
      />

      <ConceptAZModal
        isOpen={isConceptAZOpen}
        onClose={() => setIsConceptAZOpen(false)}
      />

      <RACIModal
        isOpen={isRACIOpen}
        onClose={() => setIsRACIOpen(false)}
      />

      <POC48Modal
        isOpen={isPOC48Open}
        onClose={() => setIsPOC48Open(false)}
      />

      <OverviewInAppModal
        isOpen={isOverviewInAppOpen}
        onClose={() => setIsOverviewInAppOpen(false)}
      />

      <ChatbotAIModal
        isOpen={isChatbotAIOpen}
        onClose={() => setIsChatbotAIOpen(false)}
      />

      <CodeHubERPModal
        isOpen={isCodeHubERPOpen}
        onClose={() => setIsCodeHubERPOpen(false)}
      />

      <AIHumanBOOMModal
        isOpen={isAIHumanBOOMOpen}
        onClose={() => setIsAIHumanBOOMOpen(false)}
      />

      <PositionnementModal
        isOpen={isPositionnementOpen}
        onClose={() => setIsPositionnementOpen(false)}
      />

      <CadresReferentielsModal
        isOpen={isCadresReferentielsOpen}
        onClose={() => setIsCadresReferentielsOpen(false)}
      />

      <TransparenceRadicaleModal
        isOpen={isTransparenceRadicaleOpen}
        onClose={() => setIsTransparenceRadicaleOpen(false)}
      />

      <ARIAModal
        isOpen={isARIAModalOpen}
        onClose={() => setIsARIAModalOpen(false)}
      />

      <GouvernanceProgrammationIAModal
        isOpen={isGouvernanceProgrammationIAOpen}
        onClose={() => setIsGouvernanceProgrammationIAOpen(false)}
      />


      <MachineIAModal
        isOpen={isMachineIAOpen}
        onClose={() => setIsMachineIAOpen(false)}
      />


      <ComiteTIPrismeModal
        isOpen={isGestionReunionDirectionProgOpen}
        onClose={() => setIsGestionReunionDirectionProgOpen(false)}
        title="📅 Gestion de réunion — Direction programmation"
        scope="DIRECTION_PROG"
      />

      <ProgrammationMobileModal
        isOpen={isProgrammationMobileOpen}
        onClose={() => setIsProgrammationMobileOpen(false)}
      />

      <ExpertVisionModal
        isOpen={expertVisionModal.isOpen}
        onClose={() => setExpertVisionModal({ isOpen: false, expert: null, item: null })}
        expert={expertVisionModal.expert}
        item={expertVisionModal.item}
      />


      <AIInsightBubble />
    </div>
  );
}
